function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "visa_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: -284.625,
  y1: 356.625,
  x2: -283.958,
  y2: 356.625,
  gradientTransform: "matrix(24 0 0 -8 6831 2861)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#231f5c"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#034ea2"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.1 5.4L4 10.6H2.6l-1-4.1c-.1-.3-.1-.4-.3-.5C1 5.8.5 5.7 0 5.6v-.2h2.2c.3 0 .5.2.6.5l.5 3 1.3-3.5h1.5zm5.3 3.5c0-1.4-1.8-1.4-1.8-2 0-.2.2-.4.5-.4.4 0 .9 0 1.3.2l.2-1.1c-.4-.1-.8-.2-1.2-.2C9.2 5.3 8.3 6 8.3 7c0 .7.6 1.2 1.1 1.4.5.3.7.4.7.6 0 .3-.4.5-.8.5-.6 0-1-.2-1.3-.3l-.2 1.1c.3.1.9.3 1.4.3 1.3.1 2.2-.6 2.2-1.7zm3.4 1.7H16l-1-5.2h-1.1c-.2 0-.5.2-.6.4l-1.9 4.8h1.4l.2-.8h1.7l.1.8zm-1.4-1.8l.6-2 .4 1.9-1 .1zM7.9 5.4l-1.1 5.2H5.6l1.1-5.2h1.2z",
  fill: "url(#visa_svg__a)"
});

var SvgVisa = function SvgVisa(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/visa.fa52861a.svg";
export { SvgVisa as ReactComponent };